import React from 'react';
import { observer } from 'mobx-react';
import { RecordCard } from '@project/store/shared/RecordCard';
import { List } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { AttachmentLink } from './AttachmentLink';

import '@assets/scss/index.scss';
import './style.scss';

interface FileListProps {
  card: RecordCard;
}

export const FileList: React.FC<FileListProps> = observer(function FileList({
  card,
}) {
  const { tableName, recordId } = card;
  const files = card.files;

  return (
    <List size="small">
      {files.map((item) => {
        const { fileName, attachmentId } = item;

        return (
          <List.Item key={`${tableName}-${recordId}-${attachmentId}`}>
            <List.Item.Meta
              avatar={<FileOutlined style={{ fontSize: '20px' }} />}
              title={
                <AttachmentLink
                  attachmentId={attachmentId}
                  fileName={fileName}
                  tableName={tableName}
                  recordId={recordId}
                />
              }
            />
          </List.Item>
        );
      })}
    </List>
  );
});
